import { LINK_MODE } from "constants/booksHandoff";
import { getLinkKey } from "./getLinkKey";
import { getModeKey } from "./getModeKey";

export const hasUploadOrLinkValue = (
  fieldKey: string,
  values: Record<string, unknown>
): boolean => {
  if (values?.[getModeKey(fieldKey)] === LINK_MODE) {
    return String(values?.[getLinkKey(fieldKey)] ?? "").trim() !== "";
  }

  const documents = values?.[fieldKey];
  return Array.isArray(documents) && documents.length > 0;
};
